// Continuos Bar and Multiple Line Chart Hook
import  {useMemo, useRef } from 'react'
import { ContinuousBarAndMultiLineChart } from '../classes/ContinuosBarAndMultipleLineChart'

 /* Hook returns:
     - Reference for the rendered plot
     - Object of type ChartClass
 */
 export const ContinuosBarAndMultiLineChartHook = ({parameters}) =>
 {
     
    const objectReference = useRef()
    const initialParameters = useRef(parameters)
    const chart = useMemo(() => new ContinuousBarAndMultiLineChart(initialParameters.current, objectReference),[])    
 
    return([objectReference, chart])
 
 }

